import { all } from 'redux-saga/effects'
import easeMarginSagas from './sagas'

export default function* rootSaga() {
    yield all([
        easeMarginSagas()
    ])
}